// extracted by mini-css-extract-plugin
export default {"container":"fBrlKNRM","tooltip":"MGKCtnWU","none":"gahVkbHS"};